{
  "title": "如何維護評審資料並查看評分紀錄",
  "description": "自行維護服務單位、職稱、專長與簡介，並跨競賽查看您已送出的評分。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，主辦方在評審名單看到的是您自己填寫的最新資料，您也能在同一頁面回顧所有已送出的評分。",
  "roleNote": "評審",
  "prerequisites": ["已接受評審邀請並登入"],
  "pathLabel": "評審任務 → 我的評審資料／評分紀錄",
  "steps": [
    {
      "title": "1. 開啟「我的評審資料」",
      "description": "在評審任務頁上方點「我的評審資料」。資料依競賽各自保存；若您同時是多場競賽的評審，可在頁面上方切換競賽。姓名與 Email 屬帳號資料，請到帳號選單的「帳號與安全」修改。"
    },
    {
      "title": "2. 填寫並儲存",
      "description": "可填服務單位、職稱、專長（以逗號分隔）與簡介，按「儲存」。這些資料只會顯示給該場競賽的主辦方（評審名單），不會顯示給參賽者或其他評審。"
    },
    {
      "title": "3. 查看公告",
      "description": "評審任務頁的「公告」區塊會顯示主辦方發給評審的最新公告（最多 3 則）；不是每則公告都會寄信，請定期查看。"
    },
    {
      "title": "4. 查看評分紀錄",
      "description": "在評審任務頁點「評分紀錄」，會依競賽列出您已送出的作品、總分與連結，以及每場競賽已送出的件數與平均總分。草稿與尚未開始的作品請回評審任務頁處理。"
    }
  ],
  "afterward": [
    "主辦方在評審名單看到您最新的服務單位、職稱與專長",
    "評分紀錄只顯示您本人已送出的分數，不含其他評審的資料"
  ],
  "nextSteps": "若要繼續評分，請回到評審任務頁，見「如何查看指派給我的作品」。",
  "faq": [
    {
      "q": "我換了單位，需要每場競賽都改嗎？",
      "a": "需要。評審資料是依競賽各自保存的，請在「我的評審資料」切換到各場競賽分別更新。"
    },
    {
      "q": "評分紀錄裡為什麼沒有我的草稿？",
      "a": "紀錄只列已送出的評分；草稿和尚未開始的作品在評審任務頁處理，送出後才會出現在紀錄。"
    }
  ]
}
